import { UrlCreationOptions } from '@angular/router'

export function createTreeFromURL(
  url: string
): [(string | number)[], UrlCreationOptions] {
  const queryIndex = url.indexOf('?')
  let params: Record<string, string> | undefined
  let path = url
  if (queryIndex >= 0) {
    params = Object.fromEntries(
      new URLSearchParams(path.substring(queryIndex + 1))
    )
    path = url.substring(0, queryIndex)
  }
  if (path.startsWith('/')) {
    path = path.substring(1)
  }
  const parts = path.split('/')
  if (parts.length > 0) {
    parts[0] = `/${parts[0]}`
  }
  return [parts, params ? { queryParams: params } : {}]
}
